import {takeEvery, put, fork, call, all, select} from 'redux-saga/effects';
import * as rs from './reportsSlice';
import * as uis from '../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../Auth';
import { findReportsApi } from './reportsAPI';


export function* onFindReportsStartAsync({ payload }){

    try{
        
        yield put(rs.actions.startCall({ callType: rs.callTypes.fetch }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: {
                ...payload.queryParams
            }
        };

        const response = yield call(findReportsApi, reqBody);        

        if(response.status === 200){
            let reportStr = response.data;
            yield put(rs.actions.reportsFetched({ reportStr }));
        }
    }
    catch(error){

        console.log(error);

        let errorMsg = "There was an error retrieving the reports.";

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            // yield put(uis.actions.showNotification({
            //     status:"error",
            //     title:"Error",
            //     message: errorMsg
            // }));

            yield put(rs.actions.catchError({
                callType: rs.callTypes.fetch,
                error: errorMsg
            }));
        }
    }

};

export function* onResetReportStateStartAsync({ payload }){

    try{
        
        yield put(rs.actions.startCall({ callType: rs.callTypes.list }));

        yield put(rs.actions.reportStateClear());
 
    }
    catch(error){

        console.log(error);


        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error with the request."
        // }));
    }

};

export const actionTypes = {
    FindReports: "[FindReports] Find Reports API Action",
    ResetReportState: "[ResetReportState] Reset Report State Action"
};

export const actions = {

    findReports: (queryParams) => ({ type: actionTypes.FindReports, payload: { queryParams } }),
    resetReportState: () => ({ type: actionTypes.ResetReportState, payload: { undefined } } )

};

export function* findReports(){

    yield takeEvery(actionTypes.FindReports,onFindReportsStartAsync);    
};

export function* resetReportState() {

    yield takeEvery(actionTypes.ResetReportState,onResetReportStateStartAsync);
};

const rsSagas = [
    fork(findReports),
    fork(resetReportState)
];

export function* saga(){
    yield all ([...rsSagas]);
};
